import React, { Fragment, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormGroup, Input } from 'reactstrap';

import { Form } from '../../assets/styles/components';

import ContentBox from '../../components/ContentBox';
import Submit from '../../components/Submit';

import { Creators as ResetCreators } from '../../store/ducks/resetPassword';

class ResetPassword extends Component {
  componentWillMount() {
    this.props.checkToken(this.props.match.params.token);
  }

  submitHandle = (e, baseUrl) => {
    e.preventDefault();
    this.props.resetPassword(
      e.target.password.value,
      e.target.passwordConfirmation.value,
      this.props.match.params.token,
      baseUrl,
    );
  };

  render() {
    return (
      <Fragment>
        <ContentBox title="Troca de senha" loading={this.props.loadingCheckToken}>
          <Form accept-charset="UTF-8" onSubmit={e => this.submitHandle(e, this.props.baseUrl)}>
            <FormGroup>
              <Input placeholder="Nova Senha" type="password" name="password" required />
            </FormGroup>
            <FormGroup>
              <Input
                placeholder="Repita nova senha"
                type="password"
                name="passwordConfirmation"
                required
              />
            </FormGroup>
            <Submit loading={this.props.loading} name="Trocar senha" />
          </Form>
        </ContentBox>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...state.resetPassword,
  baseUrl: state.sites.data.base_url,
});

const mapDispatchToProps = dispatch => bindActionCreators(ResetCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/resetPassword/index.js